const formTemplateEnumerators = {
  style: [1, 2],
  statusForSendNotification: [
    'opened',
    'validated',
    'rejected',
    'closed',
    'pending_signature',
    'pending_validation',
  ],
  sendClosingDocumentTo: [
    'validator',
    'owner',
    'responsible',
  ],
  priority: ['high', 'medium', 'low'],
  direction: ['horizontal', 'vertical'],
  classification: [
    'accreditation',
    'planning',
    'operation',
    'course',
    'exam',
    'training',
    'occupationalHealth',
    'legalCompliance',
    'incident',
    'actionPlan',
    'activity',
    'topic',
    'commitment',
    'evidence',
    'equipment',
  ],
  durationType: [
    'secs',
    'hours',
    'days',
    'months',
    'years',
  ],
  toolBarComponents: [
    'container',
    'table',
    'divider',
    'header1',
    'header2',
    'header3',
    'header4',
    'label',
    'paragraph',
    'link',
    'checkboxes',
    'dropdown',
    'multipleChoice',
    'textInput',
    'email',
    'numberInput',
    'phoneNumber',
    'textArea',
    'imageSelector',
    'fileSelector',
    'date',
    'dateTime',
    'time',
    'signature',
  ],
  toolbarItemConfig: [
    'display',
    'justifyContent',
    'alignItems',
    'textAlign',
    'color',
    'backgroundColor',
    'margin',
    'padding',
    'width',
    'height',
    'backgroundImage',
    'backgroundPosition',
    'backgroundSize',
    'backgroundRepeat',
    'border',
    'fontSize',
    'fontFamily',
    'fontWeight',
    'zIndex',
  ],
  fontFamily: [
    'Anton',
    'PT Serif',
    'Helvetica Neue',
    'Playfair Display',
    'Roboto Condensed',
    'Merriweather',
    'Poppins',
    'Alegreya',
    'Roboto',
    'Lato',
    'Raleway',
    'Cinzel',
    'Roboto Slab',
    'Antonio',
    'Montserrat',
    'Oswald',
    'Merriweather Sans',
    'Open Sans',
    'Arial',
    'Arial Black',
    'Comic Sans MS',
    'Courier New',
    'Georgia',
    'Impact',
    'Lucida Console',
    'Lucida Sans Unicode',
    'Palatino Linotype',
    'Tahoma',
    'Times New Roman',
    'Trebuchet MS',
    'Verdana',
  ],
  fontWeight: [
    'normal',
    'bold',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
  ],
  textAlign: [
    'start',
    'end',
    'left',
    'right',
    'center',
    'justify',
  ],
  position: [
    'static',
    'relative',
    'absolute',
    'fixed',
    'sticky',
  ],
  display: ['block', 'flex', 'none'],
  justifyContent: [
    'flex-start',
    'center',
    'flex-end',
    'space-between',
    'space-around',
  ],
  alignItems: ['flex-start', 'center', 'flex-end'],
  populateData: ['assets', 'locations', 'appUsers'],
  populateDataType: ['list', 'dynamic'],
  textTokens: ['@currentDate', '@pageNumber', '@totalPages', '@pageXofY'],
  keys: [
    'commitmentDate',
    'lateDays',
    'status',
    'number',
    'numberPrefix',
    'numberSuffix',
    'dateInitDate',
    'hourInitDate',
    'dateEndDate',
    'hourEndDate',
    'tenantName',
    'formTemplateShortName',
    'owner',
    'ownerDisplayName',
    'ownerNationalID',
    'ownerRolName',
    'ownerTenantName',
    'ownerAreaName',
    'ownerSignature',
    'ownerActionDate',
    'ownerActionHour',
    'responsible',
    'responsibleDisplayName',
    'responsibleNationalID',
    'responsibleRolName',
    'responsibleTenantName',
    'responsibleAreaName',
    'responsibleSignature',
    'responsibleActionDate',
    'responsibleActionHour',
    'participant',
    'participantDisplayName',
    'participantNationalID',
    'participantRolName',
    'participantTenantName',
    'participantAreaName',
    'participantSignature',
    'participantActionDate',
    'participantActionHour',
    'validator',
    'validatorDisplayName',
    'validatorNationalID',
    'validatorRolName',
    'validatorTenantName',
    'validatorAreaName',
    'validatorSignature',
    'validatorCommentEvidence',
    'validatorPhotoEvidence',
    'validatorActionDate',
    'validatorActionHour',
    'validatorActionStatus',
    'validationDate',
    'validationHour',
    'closedBy',
    'closedByDisplayName',
    'closedByNationalID',
    'closedByRolName',
    'closedByTenantName',
    'closedByAreaName',
    'closedBySignature',
    'closedByActionDate',
    'closedByActionHour',
    'validatedBy',
    'validatedByDisplayName',
    'validatedByNationalID',
    'validatedByRolName',
    'validatedByTenantName',
    'validatedByAreaName',
    'validatedBySignature',
    'validatedByActionDate',
    'validatedByActionHour',
    'validatedByActionStatus',
  ],
};

export default formTemplateEnumerators;
